/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { axiosInstance, axiosInstanceAdmin } from '../axiosInstance'

const getAllOrganizationApplicationsByUserID = param => {
  return axiosInstance
    .post(
      `/api/gcuser/v1/organization-application-user/getAllOrganizationApplicationsByUserID`,
      param
    )
    .then(res => res.data)
}
const getAllOrganizationApplicationsByOrgID = param => {
  return axiosInstance
    .post(
      `/api/gcuser/v1/organization-application/getAllByOrganizationID`,
      param
    )
    .then(res => res.data)
}

const getAllOrganizationApplications = param => {
  return axiosInstance
    .post(`/api/gcuser/v1/organization-application/getAllForOrg`, param)
    .then(res => res.data)
}
const getUserApplicationRole = param => {
  return axiosInstance
    .post(`api/gcuser/v1/organization-application/getRole`, param)
    .then(res => res.data)
}
const getAllByOrganizationAppicationID = param => {
  return axiosInstanceAdmin
    .post(
      `api/gcadmin/v1/organization-application-auth-provider/getAllByOrganizationAppicationID`,
      param
    )
    .then(res => res.data)
}
const getLoginIdp = param => {
  return axiosInstance
    .post(`api/gcuser/v1/user/loginSSO`, param)
    .then(res => res.data)
}
const getRoutersIdp = param => {
  return axiosInstanceAdmin
    .post(
      `api/gcadmin/v1/router/retrieveClientToken?userName=` +
        param.userName +
        `&userPass=` +
        param.userPass +
        `&routerName=` +
        param.routerName
    )
    .then(res => res.data)
}
const getOnlineOfflineStatus = param => {
  return axiosInstance
    .post(
      `api/gcuserv1/network/get-online-offline-status` 
    )
    .then(res => res.data)
}

const getNetwork = param => {
  return axiosInstance
    .post(
      `api/gcuserv1/network/get-network` 
    )
    .then(res => res.data)
}
export {
  getAllOrganizationApplicationsByUserID,
  getAllOrganizationApplications,
  getAllOrganizationApplicationsByOrgID,
  getUserApplicationRole,
  getAllByOrganizationAppicationID,
  getLoginIdp,
  getRoutersIdp,
  getOnlineOfflineStatus,
  getNetwork
}
